import moment from 'moment'
import VueI18n from '@/libs/i18n/index'

const money = (value, decimals = 2) => {
  if (typeof value === 'undefined') {
    return 'undefined'
  }
  const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: decimals,
  })
  const hasDecimals = value.toString().split('.').length === 2
  if (hasDecimals) {
    value = `${value.toString().split('.')[0]}.${value
      .toString()
      .split('.')[1]
      .slice(0, decimals)}`
  }
  const val = currencyFormatter.format(value)
  return val
}

const moneyFormat = (value, decimals = 2) => {
  if (typeof value === 'undefined') {
    return 'undefined'
  }
  const currencyFormatter = new Intl.NumberFormat({
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: decimals,
  })
  const hasDecimals = value.toString().split('.').length === 2
  if (hasDecimals) {
    value = `${value.toString().split('.')[0]}.${value
      .toString()
      .split('.')[1]
      .slice(0, decimals)}`
  }
  const val = currencyFormatter.format(value)
  return val
}

const date = (value, plus) => moment(value).add(plus, 'days').format('DD/MMM/YYYY')

const hour = (_, hours, minutes, seconds) => {
  const formattedHour = `${hours > 9 ? hours : `0${hours}`}:${
    minutes > 9 ? minutes : `0${minutes}`
  }`
  if (seconds) {
    formattedHour.concat(`:${seconds > 9 ? seconds : `0${seconds}`}`)
  }
  return formattedHour
}

const dateAndHour = value => moment(value).format('DD/MMM/YYYY HH:mm:ss')

const decimalsFilter = (value, decimals = 2) => {
  if (typeof value === 'undefined') {
    return 'undefined'
  }
  const formattedNumber = value.toFixed(decimals)
  return formattedNumber
}

const yesNoFilter = value => {
  if (value) {
    return VueI18n.global.t('yes')
  }
  return VueI18n.global.t('no')
}

const filters = {
  money,
  moneyFormat,
  date,
  hour,
  dateAndHour,
  decimals: decimalsFilter,
  yesNoFilter,
}

export default {
  install(app) {
    Object.entries(filters).forEach(([name, fn]) => {
      app.config.globalProperties[`$${name}`] = fn
    })
  },
}

// Exports para usar como funcion en setup.
export { money, date }
